import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue';
import router from './router';

import axiosPlugin from './plugins/axios';
import mercurePlugin from './plugins/mercure';
import globalEvents from "./plugins/globalEvents";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
const app = createApp(App);

app.use(pinia);
app.use(router);

app.use(axiosPlugin);
app.use(mercurePlugin);
app.use(globalEvents);

app.mount('#app');
